import axios, { AxiosError } from "axios";
import { AxiosRequestConfig } from "axios";
import { store } from "../app/mainReducer";
import getEnv from "./getEnv";
import { CANCEL } from "redux-saga";

export const APIURL: string = getEnv("REACT_APP_API_HOST");

export const getToken = () => store.getState().sistema.token;


axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status == 401) {
      window.location.href = "/logout";
      return;
    }
    return Promise.reject(error);
  }
);

export const apiCall = (config: AxiosRequestConfig) => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const request = axios({
    ...config,
    baseURL: APIURL,
    cancelToken: source.token,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${getToken()}`,
    },
  });

  (request as any)[CANCEL] = () => source.cancel();
  return request;
};
